export default {
    older: "Older",
    newer: "Newer",
}
